function Button({ onClick, text, styling='primary', className, disabled=false }) {
    let btnClasses = 'transition rounded-lg p-1 text-lg font-semibold h-10 ';
    btnClasses += disabled ? 'cursor-default ' : ''
    switch(styling) {
        case 'primary':
            btnClasses += 'bg-teal-500 border border-teal-800'
            btnClasses += disabled ? '' : ' hover:bg-teal-600'
            break;
        case 'secondary':
            btnClasses += 'bg-neutral-900 border border-gray-600'
            btnClasses += disabled ? '' : ' hover:bg-neutral-950'
            break;
        default:
            btnClasses += ''
            break;
    }

    return (
        <button onClick={onClick} className={btnClasses + ' ' + className}>{text}</button>
    )
}

export default Button;